import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function VideoReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [dark, setDark] = useState(true);
  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const res = await fetch(`https://api.mogym.ir/api/admin/video-reports`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
          },
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.Message || 'خطا در دریافت گزارش‌ها');
        setReports(data.Result || []);
      } catch (err) {
        setError(err.message || 'خطا در ارتباط با سرور');
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-4 py-10 font-vazir">
        <div className="max-w-5xl mx-auto space-y-6">
          <h1 className="text-2xl font-bold text-center mb-6">📼 لیست گزارش‌های ویدیو</h1>

          {loading && <p className="text-center">در حال دریافت اطلاعات...</p>}
          {error && <p className="text-center text-red-500">{error}</p>}

          <div className="space-y-4">
            {reports.map((report, idx) => (
              <div
                key={idx}
                onClick={() => navigate(`/admin/reports/${report.Id}`)}
                className="cursor-pointer border dark:border-gray-700 rounded-xl p-4 bg-gray-50 dark:bg-[#1c1f2b] hover:bg-gray-100 dark:hover:bg-[#252538]"
              >
                <p className="font-bold mb-2">🎯 آی‌دی حرکت: {report.ExerciseId}</p>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-1">
                  نوع گزارش: <span className={`font-bold ${report.Type === 'Broken' ? 'text-red-500' : 'text-yellow-500'}`}>{report.Type === 'Broken' ? 'ویدئوی خراب' : 'ویدئوی اشتباه'}</span>
                </p>
                {report.CreatedAt && (
                  <p className="text-xs text-gray-400">🕒 {new Date(report.CreatedAt).toLocaleString('fa-IR')}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? '☀️' : '🌙'}
        </button>
      </div>
    </div>
  );
}
